export default {
  "content": "<path d=\"M336 320H32L184 48l152 272zm-70.68-125.49A144 144 0 11192 320\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};